export class MultiStringFilterParameter {
  constructor(public keywords: string[] = []) {
  }

  filter(source: string): boolean {
    return !this.keywords
        || (this.keywords.length === 0)
        || (this.keywords.some(k => k === source));
  }

  clone(): MultiStringFilterParameter {
    return new MultiStringFilterParameter(
      this.keywords ? this.keywords.concat() : []
    );
  }
}
